export default __webpack_public_path__ + "static/media/logoNidilrr.57d9f8da.jpg";